// src/pages/Leaves.js
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Tabs, Tab, Alert } from "react-bootstrap";
import { useAuth } from "../context/AuthProvider";
import LeaveApplication from "../components/LeaveApplication";
import LeaveManagement from "../components/LeaveManagement";
import UserLeaveHistory from "../components/UserLeaveHistory";
import { getLeavesByUserId, getLeaveStats } from "../services/leaveService";
import Loader from "../components/Loader";

export default function Leaves() {
  const { user } = useAuth();
  const [userLeaves, setUserLeaves] = useState([]);
  const [leaveStats, setLeaveStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("apply");

  const isAdmin = user?.role === "admin";
  const isTutor = user?.role === "tutor";
  const canManageLeaves = isAdmin || isTutor;

  useEffect(() => {
    fetchUserData();
  }, [user]);

  const fetchUserData = async () => {
    if (!user?.id) return;

    setLoading(true);
    try {
      // Fetch user's leaves and stats
      const [leaves, stats] = await Promise.all([
        getLeavesByUserId(user.id),
        getLeaveStats(user.id),
      ]);

      setUserLeaves(leaves);
      setLeaveStats(stats);
    } catch (error) {
      console.error("Error fetching user leave data:", error);
    }
    setLoading(false);
  };

  const handleLeaveApplied = () => {
    // Refresh user data after a new leave is applied
    fetchUserData();
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <Container fluid>
      <Row>
        <Col>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="mb-0">🏖️ Leave Management</h2>
          </div>

          <LeaveManagement />
        </Col>
      </Row>
    </Container>
  );
}
